
import { BasicModel } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { TextFormat } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Constants } from "../../constants/Poker2Constants";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2SliderEvent } from "../../event/Poker2SliderEvent";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { SeatVO } from "../../gamevo/SeatVO";
import { Poker2Model } from "../../model/Poker2Model";
import { SliderHelper } from "./SliderHelper";

import { NumberStringHelper } from "../../helper/NumberStringHelper";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class TableRankingHelper {
    private rankingslider: SliderHelper;
    private rankingHeight: number = 0;
    private rankingkomponent: MovieClip;

    constructor(komponent: MovieClip) {
        this.rankingkomponent = komponent;

        // apply mask via code to fix a text view problem in flashplayer 11
        this.rankingkomponent.mc_textholder.mask = this.rankingkomponent.mc_mask;

        // init scrollbar (using slider as a scrollbar)
        this.rankingslider = new SliderHelper(this.rankingkomponent.mc_chatslider);

        // init listeners
        this.rankingkomponent.mc_chatslider.addEventListener("onSliding", this.bindFunction(this.onChatSliding));
        this.rankingkomponent.mc_chatslider.addEventListener("slideUp", this.bindFunction(this.onChatSliding));
        this.rankingkomponent.mc_chatslider.addEventListener("slideDown", this.bindFunction(this.onChatSliding));
    }

    private scrollToEnd(): void {
        if (this.rankingHeight > this.rankingkomponent.mc_mask.height) {
            this.rankingkomponent.mc_textholder.y = this.rankingkomponent.mc_mask.y - (this.rankingHeight - this.rankingkomponent.mc_mask.height);
            this.enableButtons(true);
        }
        this.updateSlider();
    }

    private onChatSliding(event: Poker2SliderEvent): void {
        if (this.rankingHeight <= this.rankingkomponent.mc_mask.height) return;
        this.rankingkomponent.mc_textholder.y = this.rankingkomponent.mc_mask.y - (this.rankingHeight - this.rankingkomponent.mc_mask.height) * event.percentValue / 100;
    }

    private updateSlider(): void {
        if (this.rankingHeight < this.rankingkomponent.mc_mask.height) return;

        var textholderY: number = int(this.rankingkomponent.mc_textholder.y - this.rankingkomponent.mc_mask.y);
        var height: number = int(-(this.rankingHeight - this.rankingkomponent.mc_mask.height));
        var percentY: number = 100 - ((height - textholderY) / height * 100);
        this.rankingkomponent.mc_chatslider.btn_slider.y = this.rankingkomponent.mc_chatslider.mc_sliderbar.y + (this.rankingkomponent.mc_chatslider.mc_sliderbar.height * percentY / 100);
    }

    public onUpdateRanking(): void {
        this.init();
        var currentTable: LobbyTablesVO = Poker2Model.onTableData.currentTable;
        var sortetSeats: any[] = [];
        for (var i: number = 0; i < currentTable.seats.length; i++) {
            var obj: any = new Object();
            obj.seatIndex = i;
            obj.data = currentTable.seats[i];
            if (currentTable.seats[i].playerId >= 0 && currentTable.seats[i].seated)
                sortetSeats.push(obj);
        }
        sortetSeats.sort(this.bindFunction(this.onSortByHandChips));
        for (var j: number = 0; j < sortetSeats.length; j++) {
            var seatVO: SeatVO = sortetSeats[j].data as SeatVO;
            this.writeNewMsg(seatVO.userId, seatVO.playerId, seatVO.name, int(Poker2Constants.SEAT_COLOR[sortetSeats[j].seatIndex]), NumberStringHelper.groupString(seatVO.handChips, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData)));
        }
    }

    private onSortByHandChips(x: any, y: any): number {
        if (x.data.handChips >= y.data.handChips) return -1;
        if (x.data.handChips < y.data.handChips) return 1;
        return 0;
    }

    private writeNewMsg(userId: number, playerId: number, playerName: string, color: number, msg: string): void {
        var namefield: Library.PokerTableActionPanel.ChatNameText = new Library.PokerTableActionPanel.ChatNameText();
        var msgfield: Library.PokerTableActionPanel.ChatMsgText = new Library.PokerTableActionPanel.ChatMsgText();

        namefield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        msgfield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;

        if (Poker2LanguageFontManager.getInstance().useDefaultFont) {
            Poker2LanguageFontManager.getInstance().changeFontByLanguage(namefield.txt_msg);
            Poker2LanguageFontManager.getInstance().changeFontByLanguage(msgfield.txt_msg);
        }
        else {
            namefield.txt_msg.embedFonts = false;
            msgfield.txt_msg.embedFonts = false;
        }
        namefield.txt_msg.text = playerName + " - ";
        namefield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        namefield.txt_msg.width = namefield.txt_msg.textWidth + 5;
        namefield.txt_msg.height = namefield.txt_msg.textHeight + 5;
        namefield.txt_msg.textColor = color;
        namefield.txt_msg.mouseEnabled = true;

        if (userId > 0 && userId != Poker2Model.userData.userID) {
            namefield.mouseChildren = false;
            namefield.userId = userId;
            namefield.playerId = playerId;
            namefield.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickNameField));
            namefield.addEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOutNameField));
            namefield.addEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOverNameField));
        }

        msgfield.mouseEnabled = false;
        msgfield.mouseChildren = false;
        msgfield.x = namefield.txt_msg.width;
        var format: TextFormat = msgfield.txt_msg.defaultTextFormat;

        msgfield.txt_msg.defaultTextFormat = format;
        msgfield.txt_msg.defaultCacheScale = Poker2LayoutManager.GAME_SCALE_FACTOR;
        msgfield.txt_msg.text = msg;
        msgfield.txt_msg.width = this.rankingkomponent.mc_mask.width - namefield.txt_msg.width - 1;
        msgfield.txt_msg.height = msgfield.txt_msg.textHeight + 5;

        msgfield.y = namefield.y = this.rankingHeight;
        msgfield.y += 1;

        this.rankingkomponent.mc_textholder.addChild(msgfield);
        this.rankingkomponent.mc_textholder.addChild(namefield);

        this.rankingHeight += int(msgfield.height - 4);

        this.scrollToEnd();
    }

    private onClickNameField(event: MouseEvent): void {
        var namefield: Library.PokerTableActionPanel.ChatNameText = event.target as Library.PokerTableActionPanel.ChatNameText;
        var paramObject: any = { id: namefield.playerId, viewId: 1 };
        BasicModel.smartfoxClient.sendMessage("gpv", [JSON.stringify(paramObject)]);
    }

    private onMouseOutNameField(event: MouseEvent): void {
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
    }
    private onMouseOverNameField(event: MouseEvent): void {
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
    }

    public init(): void {
        this.enableButtons(false);
        this.rankingHeight = 0;
        while (this.rankingkomponent.mc_textholder.numChildren > 0) {
            var child: DisplayObject = this.rankingkomponent.mc_textholder.getChildAt(0);
            if (instanceOfClass(child, "ChatNameText")) {
                child.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickNameField));
                child.removeEventListener(MouseEvent.MOUSE_OUT, this.bindFunction(this.onMouseOutNameField));
                child.removeEventListener(MouseEvent.MOUSE_OVER, this.bindFunction(this.onMouseOverNameField));
            }
            this.rankingkomponent.mc_textholder.removeChildAt(0);
        }
        this.rankingkomponent.mc_textholder.y = this.rankingkomponent.mc_mask.y;
    }

    private enableButtons(able: boolean): void {
        this.rankingkomponent.mc_chatslider.btn_slider.enableButton = able;
        this.rankingkomponent.mc_chatslider.btn_up.enableButton = able;
        this.rankingkomponent.mc_chatslider.btn_down.enableButton = able;
    }

    public destory(): void {
        this.rankingkomponent.mc_chatslider.removeEventListener("onSliding", this.bindFunction(this.onChatSliding));
        this.rankingkomponent.mc_chatslider.removeEventListener("slideUp", this.bindFunction(this.onChatSliding));
        this.rankingkomponent.mc_chatslider.removeEventListener("slideDown", this.bindFunction(this.onChatSliding));
        if (this.rankingslider) this.rankingslider.destroy();
        this.rankingslider = null;
    }

}
import { Poker2LanguageFontManager } from "../Poker2LanguageFontManager";
import { Poker2LayoutManager } from "../Poker2LayoutManager";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
